import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TreePermission } from '../../definitions/tiers.interface';

@Component({
  selector: 'app-delete-permission-dialog',
  templateUrl: './delete-permission-dialog.component.html',
  styleUrls: ['./delete-permission-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeletePermissionDialogComponent {
  constructor(
    public _dialogRef: MatDialogRef<DeletePermissionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { permission?: TreePermission }
  ) {}

  delete() {
    this._dialogRef.close('delete');
  }

  close() {
    this._dialogRef.close();
  }
}
